import type { AxiosInstance } from 'axios';

export const UserService = (api: AxiosInstance) => ({
  // Get list of users
  getUsers: async (searchTerm?: string) => {
    const url = searchTerm
      ? `/admin/users?search=${encodeURIComponent(searchTerm)}`
      : '/admin/users';

    const response = await api.get(url);
    return response.data;
  },

  // Get users by IDs (batch fetch)
  getUsersByIds: async (userIds: string[]) => {
    if (userIds.length === 0) return [];
    const response = await api.get('/admin/users', {
      params: { ids: userIds.join(',') }
    });
    return response.data.items || [];
  },

  // Get available statuses
  getStatuses: async () => {
    const response = await api.get('/admin/users/statuses');
    return response.data;
  },

  // Update user status
  updateStatus: async (userId: string, status: string) => {
    const response = await api.put(
      `/admin/users/${userId}/status`,
      { status }
    );
    return response.data;
  },

  // Update user details
  updateUser: async (userId: string, updates: { name?: string; picture?: string }) => {
    const response = await api.put(
      `/admin/users/${userId}`,
      updates
    );
    return response.data;
  },

  // Get available roles
  getRoles: async () => {
    const response = await api.get('/admin/users/roles');
    // sort roles by name before returning
    const sortedRoles = response.data.sort((a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name));
    return sortedRoles;
  },

  addUserRole: async (userId: string, roleId: string) => {
    await api.post(
      `/admin/users/${userId}/roles`,
      { roleId }
    );
  },

  removeUserRole: async (userId: string, roleId: string) => {
    await api.delete(
      `/admin/users/${userId}/roles/${roleId}`
    );
  },

  getUserSessions: async (userId: string) => {
    const response = await api.get(`/admin/users/${userId}/sessions`);
    return response.data.sessions;
  },

  revokeUserSession: async (userId: string, sessionId: string) => {
    const response = await api.delete(`/admin/users/${userId}/sessions/${sessionId}`);
    return response.data;
  },

  revokeAllUserSessions: async (userId: string) => {
    const response = await api.delete(`/admin/users/${userId}/sessions`);
    return response.data;
  },
}); 